'use strict';

var processInclude = require('base/util');

$(function () {
    processInclude(require('./storeLocator/storeLocator'));
});
